export default __webpack_public_path__ + "static/media/music-catalog-white.bc778d2f.svg";